import Vue from "vue"
import gql from "graphql-tag"

// defino variables y funciones globales
export default Vue.mixin({
	async beforeMount() {
		if (this.$store && ( !this.$store.state.cart || !this.$store.state.cart.products )) {
			this.$store.commit("saveCart", {
				products: [],
				totals: {
					subTotal: 0,
					taxes: 0,
					grandTotal: 0
				}
			})
		}
	},
	methods: {
		async addToCart(product, qty, variant) {
			
			let cart = this.$store.state.cart

			let alreadyExists = -1
			if (cart.products.length > 0) {
				alreadyExists = cart.products.findIndex((p) => {
					if(p.product.id == product.id) {
						if(variant && p.variant && p.variant.id == variant.id) return p
						if(!variant && !p.variant) return p
					}
				})
			}
			
			if (alreadyExists >= 0 ) {
				// if (cart.products[alreadyExists].qty + qty > product.stockAvailable) {
				// 	this.$toast.error("No hay mas items disponibles")
				// 	return null
				// }
				cart.products[alreadyExists].qty += qty
				cart.products[alreadyExists].priceSubtotal =
					cart.products[alreadyExists].priceUnit * cart.products[alreadyExists].qty
			} else {
				// if (qty > product.stockAvailable) {
				// 	this.$toast.error("No hay mas items disponibles")
				// 	return null
				// }

				cart.products.push({
					product,
					priceUnit: product.priceWithoutTaxes,
					qty: qty,
					priceSubtotal: product.priceWithoutTaxes * qty,
					variant
				})
			}
			cart.lastAdded = {
				product,
				priceUnit: product.priceWithoutTaxes,
				qty: qty,
				priceSubtotal: product.priceWithoutTaxes * qty,
				variant
			}
			// calculo totales
			
			await this.calcTotals()
			this.$store.commit("saveCart", cart)
			this.$store.commit("setCatdAdded", true)

			setTimeout(() => {
				this.$store.commit("setCatdAdded", false)
			}, 120)
			// this.$gtag.event('productAddedToCart', { product: product.name })
		},

		async calcTotals() {
			let cart = this.$store.state.cart
			console.log('calcTotals', cart)
			let totalQty = 0
			let subTotal = 0
			
			for await (let p of cart.products) {
				p.priceSubtotal = p.priceUnit * p.qty
				subTotal += p.priceUnit * p.qty
				totalQty += p.qty
			}

			let grandTotal = subTotal * 1.22
			let taxes = grandTotal - subTotal

			cart.priceSubtotal = subTotal
			cart.priceTaxes = taxes
			cart.priceTotal = grandTotal
			cart.totalQty = totalQty
			this.$store.commit("saveCart", cart)
		},

		async cartQuantity(action, index) {
			let cart = this.$store.state.cart
			if (action == "subtract") {
				if (cart.products[index].qty > 1) {
					cart.products[index].qty--

					if (cart.products[index].qty > cart.products[index].product.stockAvailable) {
						cart.products[index].stockInsufficient = true
					} else {
						cart.products[index].stockInsufficient = false
					}
				} else if (cart.products[index].qty == 1) {
					// elimino el producto.
					cart.products.splice(index, 1)
				}
			}
			if (action == "add") {
				if (cart.products[index].qty >= cart.products[index].product.stockAvailable) {
					this.$toast.error("No hay mas items disponibles")
				} else {
					cart.products[index].qty++
				}
			}
			this.$store.commit("saveCart", cart)
			await this.calcTotals()
		},

		async cartRemoveItem(productId) {
			let cart = this.$store.state.cart
			let index = cart.products.findIndex((p) => {
				return p.product.id == productId
			})
			cart.products.splice(index, 1)
			this.$store.commit("saveCart", cart)
			await this.calcTotals()
		},

		async updateCartProducts() {
			let cart = this.$store.state.cart
			for await (let p of cart.products) {
				const product = await this.loadProduct(p.product.id)
				// marco error de que el stock no es suficiente, para trancar la orden que la tenga que modificar.
				// p.stockInsufficient = false
				// if (p.qty > product.stockAvailable) {
				// 	p.stockInsufficient = true
				// }
				p.product.priceWithoutTaxes = product.priceWithoutTaxes
				// p.product.stockAvailable = product.stockAvailable
				p.priceUnit = product.priceWithoutTaxes
			}
			this.$store.commit("saveCart", cart)
			await this.calcTotals()
		},

		async loadProduct(id) {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							product(id: $id) {
								id
								name
								priceWithoutTaxes
								hasStock
							}
						}
					`,
					variables: { id },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					return data.product
				})
				.catch((err) => {
					console.log(err)
					return null
				})
		},

		emptyCart() {
			this.$store.commit("deleteCart")
		},

		getValidUrlParams() {
			// parseo las variables de url y devuelvo un objecto con los valres validos
			var items = this.$route.query
			// si tiene paginacion se la pongo en
			if (items.length) {
				this.pagination.length = parseInt(items.length)
			}

			if (items.page) {
				this.pagination.page = items.page
				this.pagination.skip = (items.page - 1) * this.pagination.length
				delete items.page
			}

			if (items.startDate) items.startDate = this.$moment(items.startDate).format("YYYY-MM-DD 00:00:00")

			if (items.endDate) items.endDate = this.$moment(items.endDate).format("YYYY-MM-DD 23:59:59")

			var result = {}
			Object.keys(items).forEach((key) => {
				var item = items[key]
				if (Array.isArray(item)) {
					// si es un array como pro ejemplo period period, limpio los valores vacioss
					item = item.filter(Boolean)
				}
				if (item != "" && item != null && item.length > 0) {
					result[key] = item
				}
			})
			return result
		},

		cleanFilters() {
			var items = this.filters
			var result = {}
			Object.keys(items).forEach((key) => {
				const item = items[key]
				if (item != "") {
					result[key] = item
				}
			})
			return result
		},

		updateFilters() {
			let params = this.cleanFilters()

			if (params.startDate) params.startDate = this.$moment(params.startDate).format("YYYY-MM-DD")
			if (params.endDate) params.endDate = this.$moment(params.endDate).format("YYYY-MM-DD")
			// elimino elmentos del objeto que esten vacios
			params = Object.fromEntries(Object.entries(params).filter(([_, v]) => v != null))
			delete this.filters.page
			this.$router.replace({ query: params })
		}
	}
})
